import { render, staticRenderFns } from "./RoutesCheck.vue?vue&type=template&id=ab860d8a"
import script from "./RoutesCheck.vue?vue&type=script&lang=js"
export * from "./RoutesCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports